<template>
  <!-- Corpo -->
  <div class="bg-white rounded-lg shadow-md p-6 mb-4">
    <div class="flex justify-center">
      <img :src="`/images/icons/reception-digitale/loghi-aziendali/`+$page.props.customer?.slug+`/loghi.png`" class="h-20">
    </div>
  </div>
  
  <div class="bg-white rounded-lg shadow-md p-6 mb-4">
    <Transition name="fade" mode="out-in">
      <h1 v-if="!deposited" key="waiting" class="text-center text-2xl font-bold mb-4">
        Il destinatario del pacco è stato avvisato della consegna.<br>
        Depositare il pacco qui accanto negli appositi spazi destinati alla consegna.
      </h1>
      <h1 v-else key="completed" class="text-center text-2xl font-bold mb-4">
        Grazie e arrivederci!
      </h1>
    </Transition>
    
    <Transition name="slide-fade" mode="out-in">
      <div v-if="!deposited" key="form">
        <p class="text-center text-xl">
          Confermare di aver depositato il pacco cliccando sul pulsante qui sotto.
        </p>
        <div class="flex justify-center mt-6">
          <div
              @click="setDeposited()"
              class="bg-white dark:bg-gray-900 shadow-md rounded-lg p-4 h-36 flex flex-col items-center justify-start text-center cursor-pointer hover:shadow-lg transition
                    w-full sm:w-48 max-w-48"
          >
              <img :src="`/images/icons/reception-digitale/pacco.png`" class="h-14 mb-2">
              <p class="text-base font-semibold text-gray-900 dark:text-gray-100 mb-1">Pacco depositato</p>
              <p class="text-xs text-gray-600 dark:text-gray-400">Package deposited</p>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { router } from '@inertiajs/vue3';
import LayoutNoHeader from '@/Layouts/LayoutNoHeader.vue';
import axios from 'axios';

export default {
  layout: LayoutNoHeader,
  props: ['courierDelivery'],
  data() {
    return {
      pollingInterval: null,
      deposited: false
    };
  },
  beforeUnmount() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },
  methods: {
    async setDeposited() {
      try {
        await axios.get(route('modules.rd-corriere-conferma-deposito', { courierDelivery: this.courierDelivery }));
        this.deposited = true;
        clearInterval(this.pollingInterval);

        setTimeout(() => {
          router.visit(route('modules.home', { slug: 'reception-digitale' }));
        }, 10000);

      } catch (error) {
        console.error('Error:', error);
      }
    }
  }
};
</script>
